import { useEffect, useState } from 'react';
import { useNavigate, useLocation } from '@usas/ui-web/wrappers/ReactRouterDom';

import OrgUnitAdminUserConstants from '../OrgUnitAdminUserConstants';
import NavLinks from '../../../meet/NavLinks';
import EntryNavLinks from '../../EntryNavLinks';
import MyMeetsNavLinks from '../../../myMeets/MyMeetsNavLinks';

import useOmeMeetData from '../../../../state/omeMeet/UseOmeMeetData';
import useOmeMeetOrgUnitEntryData from '../../../../state/omeMeetOrgUnitEntry/UseOmeMeetOrgUnitEntryData';
import useOmeMeetOrgUnitEntryInfoData from '../../../../state/omeMeetOrgUnitEntryInfo/UseOmeMeetOrgUnitEntryInfoData';
import useOmeMeetOrgUnitNonAthleteEntryData from '../../../../state/omeMeetOrgUnitNonAthleteEntry/UseOmeMeetOrgUnitNonAthleteEntryData';
import useOUAdminEntryContextData from '../../../../state/ouAdminEntryContextView/UseOUAdminEntryContextData';
import useMyMeetsFiltersData from '../../../../state/myMeetsFilters/UseMyMeetsFiltersData';

import useSearchMeetData from '@usas/ui-web/state/searchMeet/UseSearchMeetData';
import useSelectOrgUnitData from '@usas/ui-web/state/selectOrgUnit/UseSelectOrgUnitData';
import useLeftNavModalData from '@usas/ui-web/state/leftNavModal/UseLeftNavModalData';

import Constants from '@usas/ui-web/utils/Constants';
import { formatDate } from '@usas/ui-web/utils/DateFunctions';
import { credentialsIsComplete } from '../../../../components/leftNavigationOmeTeamEntry/LeftNavValidation';

const INITIAL_MODAL_STATE = {
  displayPopUp: false,
  modalTitle: 'Delete Credential from Team Entry?',
  credentialName: '',
  memberId: '',
  email: '',
  isInGoodStanding: '',
  isInGoodStandingExpirationDate: '',
  typeName: '',
  orgUnitNonAthleteEntryId: Constants.DEFAULT_ID
};

const useOrgUnitAdminCredentials = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { omeMeetState } = useOmeMeetData();
  const { omeMeetOrgUnitEntryState } = useOmeMeetOrgUnitEntryData();
  const { omeMeetOrgUnitEntryInfoState, getOmeMeetOrgUnitEntryInfo } = useOmeMeetOrgUnitEntryInfoData();
  const { omeMeetOrgUnitNonAthleteEntryState, getOrgUnitNonAthleteEntryCredentials,
    deleteOrgUnitNonAthleteEntry } = useOmeMeetOrgUnitNonAthleteEntryData();
  const { oUAdminEntryContextState } = useOUAdminEntryContextData();
  const { searchMeetState, setSearchMeetState } = useSearchMeetData();
  const { selectOrgUnitState } = useSelectOrgUnitData();
  const { myMeetsFiltersState } = useMyMeetsFiltersData();
  const { leftNavModalState, setLeftNavModalState } = useLeftNavModalData();
  const [state, setState] = useState({ tryGet: false, submitButton: '', tryRedirect: false, error: '' });
  const [modalState, setModalState] = useState(INITIAL_MODAL_STATE);

  const onAddCredential = (e) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }
    if (omeMeetState.route === '') {
      //OME Route
      navigate(EntryNavLinks.OU_ADMIN_CREDENTIALS_SELECTION);
    }
    else {
      //Meet Route
      navigate(NavLinks.OU_ADMIN_CREDENTIALS_SELECTION);
    }
  };

  const onDeleteCredentialClicked = (e, credential) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }

    setModalState({
      ...modalState,
      displayPopUp: true,
      credentialName: (credential.firstName || credential.middleName || credential.lastName) ? `${credential.firstName || ''} ${credential.preferredName !== '' && credential.preferredName !== credential.firstName ? '"' + credential.preferredName + '"' : ''} ${credential.middleName || ''} ${credential.lastName || ''}` : '',
      memberId: credential.memberId || '',
      email: credential.email || '',
      isInGoodStanding: credential.isInGoodStanding === true ? 'Yes' : credential.isInGoodStanding === false ? 'No' : '',
      isInGoodStandingExpirationDate: credential.isInGoodStandingExpirationDate ? formatDate(credential.isInGoodStandingExpirationDate) : '',
      typeName: credential.typeName,
      orgUnitNonAthleteEntryId: credential.orgUnitNonAthleteEntryId || Constants.DEFAULT_ID
    });
  };

  const onModalCanceled = (e) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }

    setModalState(INITIAL_MODAL_STATE);
  };

  const onDeleteCredential = (e, orgUnitNonAthleteEntryId) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }

    deleteOrgUnitNonAthleteEntry(orgUnitNonAthleteEntryId);
    onModalCanceled();
    setState({ ...state, tryGet: true, error: '' });
  };

  const onNextButtonClicked = (e) => {
    if (e?.preventDefault) {
      e.preventDefault();
    }
    setState({ ...state, submitButton: OrgUnitAdminUserConstants.CONTINUE, tryRedirect: true, error: '' });
  };

  const onSaveAndExitButtonClicked = (e) => {
    if (e?.preventDefault) {
      e.preventDefault();
    }
    setState({ ...state, submitButton: OrgUnitAdminUserConstants.SAVE_AND_EXIT, tryRedirect: true, error: '' });
  };

  const onBackButtonClicked = (e) => {
    if (e?.preventDefault) {
      e.preventDefault();
    }
    setState({ ...state, submitButton: OrgUnitAdminUserConstants.BACK, tryRedirect: true, error: '' });
  };

  useEffect(() => {
    setLeftNavModalState({ ...leftNavModalState, formStateSaved: true });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (location.state && location.state?.tryGet === true) {
      setState({ ...state, tryGet: true });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (omeMeetOrgUnitEntryState.isObjLoaded === true && omeMeetOrgUnitEntryState?.objData?.omeMeetOrgUnitEntryId && omeMeetOrgUnitNonAthleteEntryState.isSaving === false) {
      if ((omeMeetOrgUnitNonAthleteEntryState.isArrayLoaded === false || state.tryGet === true)
        && omeMeetOrgUnitNonAthleteEntryState.isArrayLoading === false) {
        getOrgUnitNonAthleteEntryCredentials(omeMeetOrgUnitEntryState?.objData.omeMeetOrgUnitEntryId);
        //Make sure to get info when credentials change
        getOmeMeetOrgUnitEntryInfo(omeMeetOrgUnitEntryState?.objData?.omeMeetOrgUnitEntryId);
        if (state.tryGet === true) {
          setState({ ...state, tryGet: false, error: '' });
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [omeMeetOrgUnitEntryState, omeMeetOrgUnitNonAthleteEntryState, state.tryGet])

  useEffect(() => {
    if (omeMeetOrgUnitNonAthleteEntryState.isSaving === false && state.tryRedirect === true) {
      if (state.submitButton === OrgUnitAdminUserConstants.CONTINUE) {
        if (credentialsIsComplete(omeMeetOrgUnitEntryInfoState.objData) === false) {
          setState({
            ...state, tryRedirect: false, submitButton: '', error: `The current credentials exceed the number of allowed credentials according to the meet's deck pass rules. With the current roster, ${omeMeetOrgUnitEntryInfoState.objData?.maxCredentialNumber ?? ''} credential${omeMeetOrgUnitEntryInfoState.objData?.maxCredentialNumber === 1 ? ' is' : 's are'} allowed. ${omeMeetOrgUnitEntryInfoState.objData?.credentialsCanBeAddedAfterCap === true ? 'Only massage credentials can be added after the cap has been reached.' : 'No credentials can be added after the cap has been reached.'}`
          });
        }
        else {
          if (omeMeetState.route !== '') {
            navigate(NavLinks.OU_ADMIN_REPORTING);
          }
          else {
            navigate(EntryNavLinks.OU_ADMIN_REPORTING);
          }
        }
      }
      else if (state.submitButton === OrgUnitAdminUserConstants.SAVE_AND_EXIT) {
        if (omeMeetState.route !== '') {
          setSearchMeetState({ ...searchMeetState, showMeetHeader: true });
          navigate(NavLinks.MEET_ENTRY_TEAM, { state: { tryGetOmeMeet: true } });
        }
        else {
          navigate(MyMeetsNavLinks.MEET_ENTRY_TEAM, { state: { selectOrgUnitState: selectOrgUnitState, myMeetsFiltersState: myMeetsFiltersState } });
        }
      }
      else if (state.submitButton === OrgUnitAdminUserConstants.BACK) {
        if (omeMeetState.route !== '') {
          navigate(NavLinks.OU_ADMIN_RELAY_ENTRIES);
        }
        else {
          navigate(EntryNavLinks.OU_ADMIN_RELAY_ENTRIES);
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [omeMeetOrgUnitNonAthleteEntryState.isSaving, state, omeMeetOrgUnitEntryInfoState.objData]);


  return {
    state,
    oUAdminEntryContextState,
    modalState,
    omeMeetOrgUnitNonAthleteEntryState,
    omeMeetOrgUnitEntryInfoState,
    onAddCredential,
    onDeleteCredentialClicked,
    onModalCanceled,
    onDeleteCredential,
    onNextButtonClicked,
    onSaveAndExitButtonClicked,
    onBackButtonClicked
  };
}

export default useOrgUnitAdminCredentials;